<template>
	<div id="result" v-if="loaded">
		<div class="main">
		  <div class="box">
		    <div class="pointbox">
		      <div class="point">{{subjectlog.chengji.point}}<span>{{subjectlog.hege ? '合格' : '不合格'}}</span>
		      </div>
		    </div>
		  </div>
		  <div class="countbox">
		    <div class="result_txt">{{subjectlog.chengji.point_str}}</div>
		    <div class="ul">
		      <div class="li" v-for="item in subjectlog.textList">
			<div>{{item.title}}</div>
			<div>{{item.value}}</div>
		      </div>
		    </div>
		  </div>
		  <div class="btn">
		    <div v-on:click="location_subjectlist">查看错题</div>
		    <div v-if="data_type != 'compensate'" v-on:click="location_again">重新考试</div>
		    <div v-if="data_type == 'compensate'" v-on:click="location_back">返回</div>
		  </div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Result',
	data () {
		return {
			loaded:false,
			subjectlog:{
				chengji:{}
			}
		}
	},
	created (){
		var that = this;
		var options = this.$route.query
		this.$wx.removeStorageSync('timelimit_' + options.subjectlog_id);
		    this.$app.r('/api/subjectlog/detail',{
		      subjectlog_id:options.subjectlog_id
		    },function(response){
		      that.setData({
			subjectlog:response.data,
			data_type:options.data_type,
			loaded:true
		      });
		    },function(response){
		      that.$wx.showToast({
			title: response.message,
		      });
		    });
	},
	computed: {
	},
	methods:{
		setData(params){
			for(var n in params){
				this[n] = params[n]
			}
		},
		goFee(item){
			this.$router.push({path: '/fee', query: {
				qcolumn:this.$route.query.qcolumn,
				cartype:this.$route.query.cartype,
				chapter:item.id,
				subject_type:'chapter'
			}});
		},
		location_subjectlist: function () {
		    this.$wx.navigateTo({
		      url: '/subjectlistresult?id=' + this.subjectlog.id,
		    })
		},
		location_again:function(){

		    if(this.subjectlog.subject_type == 'freefee'){
		      this.$wx.redirectTo({
			url: '/fee',
		      });
		    } else if (this.subjectlog.subject_type == 'exam'){
		      this.$wx.redirectTo({
			url: '/fee?' + this.subjectlog.again_param,
		      });
		    } else if (this.subjectlog.subject_type == 'rand') {
		      this.$wx.redirectTo({
			url: '/fee?' + this.subjectlog.again_param,
		      });
		    } else if (this.subjectlog.subject_type == 'chapter') {
		      this.$wx.redirectTo({
			url: '/fee?' + this.subjectlog.again_param,
		      });
		    } else if (this.subjectlog.subject_type == 'special') {
		      this.$wx.redirectTo({
			url: '/fee?' + this.subjectlog.again_param,
		      });
		    } else if (this.subjectlog.subject_type == 'learn') {
		      this.$wx.redirectTo({
			url: '/fee?' + this.subjectlog.again_param,
		      });
		    }
		}
	}
}
</script>
<style scoped>
#result{
	background-color:#41d9ff;
	min-height:100vh;
}
.main{
  min-height:100%;
  background-color:#41d9ff;
  padding-bottom:50px;
}
.main .box{
  margin-top:20px;
  width:74vw;
  margin:auto;
  border-bottom:6px solid #1a8fac;
  border-radius:3px;
}
.pointbox{
  padding-top:40px;
  color:#FFFFFF;
}
.pointbox .point{
  width:130px;
  height:115px;
  margin:auto;
  background-image:url("http://jk.ioccn.com/jiakao/result_icon2.png");
  background-size:100%;
  background-repeat:no-repeat;
  background-position:center center;
  text-align:center;
  font-size:48px;
}
.pointbox .point span{
  display:block;
  font-size:14px;
}
.countbox{
  padding-bottom:20px;
  padding-top:15px;
  width:70vw;
  margin:auto;
  background-color:#FFFFFF;
  border-radius:0px 0px 10px 10px;
  margin-top:-3px;
}
.countbox .ul{
  margin:10px 0px 0px 0px;
}
.countbox .ul .li{
  display:flex;
  line-height:35px;
}
.countbox .ul .li div{
  flex:1;
  font-size:16px;
}
.countbox .ul .li div:first-child{
  text-align:right;
  padding-right:10px;
  color:#959595;
  font-weight:400;
}
.countbox .ul .li div:last-child{
  padding-left:10px;
  font-weight:400;
}
.countbox .result_txt{
  margin:auto;
  line-height:12vw;
  font-size:9vw;
  text-align:center;
  color:#41d9ff;
}
.btn{
  margin-top:25px;
  display:flex;
}
.btn div{
  flex:1;
  line-height:40px;
  background-color:#FFFFFF;
  color:#1a8fac;
  text-align:center;
  border-radius:20px;
}
.btn div:first-child{
  margin-left:20px;
  margin-right:10px;
}
.btn div:last-child{
  margin-left:10px;
  margin-right:20px;
}
</style>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             



// WEBPACK FOOTER //
// src/components/Result.vue